import User from "./user.model";
import Application from "./application.model";
import { countries } from "moment-timezone/data/meta/latest.json";

export default class Session {
    constructor(json) {
        json = json || {};
        this.token = json.token || null;
        this.roles = json.roles || [];
        this.user = new User(json.user);
        this.applications = (json.applications || []).map((json) => new Application(json));
    }

    /**
     * Getter
     * @returns {boolean}
     */
    get valid() {
        return !!this.token;
    }

    get currentTimezone() {
        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/London';

        const currentUserCountry = Object.entries(countries).filter(([, countryData]) => {
            return countryData.zones && countryData.zones.includes(userTz);
        });

        return currentUserCountry.length > 0 ? currentUserCountry[0][0] : 'GB';
    }
}